import _Space from "@arco-design/web-react/es/Space";
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Wcag from './wcag';
import { RGBToHex } from './utils';
import { GlobalContext } from '@src/context';
var InspectorPanel = function (_super) {
  __extends(InspectorPanel, _super);
  function InspectorPanel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.container = null;
    return _this;
  }
  InspectorPanel.prototype.componentDidMount = function () {
    var _this = this;
    this.createContainer();
    this.timer = setTimeout(function () {
      if (!_this.container) {
        _this.createContainer();
      }
    });
  };
  InspectorPanel.prototype.componentWillUnmount = function () {
    clearTimeout(this.timer);
  };
  InspectorPanel.prototype.createContainer = function () {
    var getContainer = this.props.getContainer;
    this.container = getContainer && getContainer();
    this.forceUpdate();
  };
  InspectorPanel.prototype.render = function () {
    var _a = this.props,
      baseInfo = _a.baseInfo,
      domClass = _a.domClass,
      wcagInfo = _a.wcagInfo;
    var lang = this.context.lang;
    var front = wcagInfo.front,
      backgroundColor = wcagInfo.backgroundColor;
    if (this.container) {
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "selector-desc"
      }, /*#__PURE__*/React.createElement("span", null, lang === 'zh-CN' ? '选择器' : 'Selector', "-"), /*#__PURE__*/React.createElement("span", null, domClass)), /*#__PURE__*/React.createElement(_Space, {
        direction: "vertical",
        style: {
          width: '100%'
        }
      }, baseInfo.map(function (el) {
        return /*#__PURE__*/React.createElement("div", {
          className: "inspector-item",
          key: el.type
        }, /*#__PURE__*/React.createElement("div", {
          className: "item-icon"
        }), /*#__PURE__*/React.createElement("div", {
          className: "item-label"
        }, el.label), /*#__PURE__*/React.createElement("div", {
          className: "item-line"
        }), !['color', 'backgroundColor'].includes(el.type) ? /*#__PURE__*/React.createElement("div", {
          className: "item-value"
        }, el.value) : /*#__PURE__*/React.createElement("div", {
          className: "item-value"
        }, /*#__PURE__*/React.createElement("span", {
          className: "rect",
          style: {
            background: el.value
          }
        }), RGBToHex(el.value)));
      })), front && backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' ? /*#__PURE__*/React.createElement(Wcag, __assign({}, wcagInfo)) : null), this.container);
    }
    return null;
  };
  return InspectorPanel;
}(Component);
InspectorPanel.contextType = GlobalContext;
export default InspectorPanel;